@if (
  {
    resetOtpData: resetOtpData$ | async,
    isResetFormValid: isResetFormValid$ | async,
    isResettingUserPassword: isResettingUserPassword$ | async,
    violations: violations$ | async
  };
  as STATE
) {
  <form
    class="form"
    [formGroup]="resetForm"
    (ngSubmit)="onSubmit()"
    [ngxsForm]="statePropertyPath"
    autocomplete="off"
  >
    <div class="form__group">
      <label for="email" class="form__label">Adresse électronique</label>
      <div class="form__item form__item--with-prefix form__item--readonly">
        <span class="form__prefix">
          <mat-icon svgIcon="dgi-msg" color="primary"></mat-icon>
        </span>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="form__input"
          placeholder="Adresse e-mail"
          [readonly]="email?.disabled"
          autocomplete="off"
        />
      </div>
      <mat-error
        *ngIf="email?.touched && email?.errors?.required"
        class="form__error-red"
      >
        Ce champ est requis
      </mat-error>
      <mat-error
        *ngIf="email?.touched && email?.errors?.email"
        class="form__error-red"
      >
        Veuillez entrer une adresse e-mail valide
      </mat-error>
      <mat-error
        *ngIf="email?.getError('httpError') as httpError"
        class="form__error-red"
      >
        {{ httpError }}
      </mat-error>
    </div>

    <div class="form__group">
      <label for="token" class="form__label"
        >Code OTP
        <span class="form__label--required">*</span>
      </label>
      <div class="form__item form__item--with-prefix">
        <span class="form__prefix">
          <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
        </span>
        <input
          formControlName="token"
          id="token"
          type="text"
          class="form__input"
          placeholder="Saisir le code à 6 chiffres"
          maxlength="6"
          inputmode="numeric"
          pattern="[0-9]{6}"
          (keydown)="onOtpKeydown($event)"
          autocomplete="one-time-code"
        />
      </div>

      <mat-error *ngIf="tokenControl?.hasError('expiredOtp')">
        Le code de vérification a expiré. Veuillez cliquer sur "Renvoyer le code
        de vérification".
      </mat-error>
      <mat-error
        *ngIf="tokenControl?.touched && tokenControl?.errors?.required"
        class="form__error-red"
      >
        Ce champ est requis
      </mat-error>
      <mat-error
        *ngIf="tokenControl?.touched && tokenControl?.errors?.pattern"
        class="form__error-red"
      >
        Le code doit contenir 6 chiffres
      </mat-error>
      <mat-error
        *ngIf="tokenControl?.getError('httpError') as httpError"
        class="form__error-red"
      >
        {{ httpError }}
      </mat-error>
    </div>

    <div class="form__countdown">
      <auth-countdown
        [expiresAt]="STATE.resetOtpData?.expiresAt || expiresAt"
        (resendOtp)="onOtpResend()"
      ></auth-countdown>
    </div>

    <mat-divider class="form__divider"></mat-divider>

    <ng-container *ngIf="{ value: false } as togglePassword">
      <div class="form__group">
        <label for="password" class="form__label"
          >Nouveau mot de passe
          <span class="form__label--required">*</span>
        </label>
        <div class="form__item form__item--with-prefix">
          <span class="form__prefix">
            <mat-icon svgIcon="dgi-password" color="primary"></mat-icon>
          </span>
          <input
            matInput
            formControlName="password"
            id="password"
            [type]="togglePassword.value ? 'text' : 'password'"
            class="form__input"
            placeholder="Saisir le mot de passe"
            required
            autocomplete="new-password"
          />
          <button
            type="button"
            mat-icon-button
            (click)="togglePassword.value = !togglePassword.value"
            tabindex="-1"
            class="form__suffix"
            aria-label="Afficher ou masquer le mot de passe"
          >
            <mat-icon
              [svgIcon]="togglePassword.value ? 'dgi-view' : 'dgi-view_off'"
            ></mat-icon>
          </button>
        </div>
        @if (password?.touched && password?.errors?.required) {
          <mat-error
            [innerHtml]="'Ce champ est requis'"
            class="form__error-red"
          ></mat-error>
        }
        @if (password?.touched && password?.errors?.minlength) {
          <mat-error
            [innerHtml]="'Minimum 8 caractères'"
            class="form__error-red"
          ></mat-error>
        }
        @if (password?.touched && password?.errors?.uppercase) {
          <mat-error
            [innerHtml]="'Le mot de passe doit contenir au moins une majuscule'"
            class="form__error-red"
          ></mat-error>
        }
        @if (password?.touched && password?.errors?.lowercase) {
          <mat-error
            [innerHtml]="'Le mot de passe doit contenir au moins une minuscule'"
            class="form__error-red"
          ></mat-error>
        }
        @if (password?.touched && password?.errors?.digit) {
          <mat-error
            [innerHtml]="'Le mot de passe doit contenir au moins un chiffre'"
            class="form__error-red"
          ></mat-error>
        }
        @if (password?.touched && password?.errors?.specialChar) {
          <mat-error
            [innerHtml]="
              'Le mot de passe doit contenir au moins un caractère spécial'
            "
            class="form__error-red"
          ></mat-error>
        }
        <mat-error
          *ngIf="password?.getError('httpError') as httpError"
          class="form__error-red"
        >
          {{ httpError }}
        </mat-error>
      </div>
    </ng-container>

    <ng-container *ngIf="{ value: false } as toggleConfirmPassword">
      <div class="form__group">
        <label for="confirmPassword" class="form__label"
          >Confirmation du mot de passe
          <span class="form__label--required">*</span>
        </label>
        <div class="form__item form__item--with-prefix">
          <span class="form__prefix">
            <mat-icon svgIcon="dgi-password" color="primary"></mat-icon>
          </span>
          <input
            matInput
            formControlName="confirmPassword"
            id="confirmPassword"
            [type]="toggleConfirmPassword.value ? 'text' : 'password'"
            class="form__input"
            placeholder="Confirmer le mot de passe"
            required
            autocomplete="new-password"
          />
          <button
            type="button"
            mat-icon-button
            (click)="toggleConfirmPassword.value = !toggleConfirmPassword.value"
            tabindex="-1"
            class="form__suffix"
            aria-label="Afficher ou masquer le mot de passe"
          >
            <mat-icon
              [svgIcon]="
                toggleConfirmPassword.value ? 'dgi-view' : 'dgi-view_off'
              "
            ></mat-icon>
          </button>
        </div>
        <mat-error
          *ngIf="confirmPassword?.touched && confirmPassword?.errors?.required"
          class="form__error-red"
        >
          Ce champ est requis
        </mat-error>
        <mat-error
          *ngIf="
            confirmPassword?.touched &&
            confirmPassword?.errors?.['passwordsMismatch']
          "
          class="form__error-red"
        >
          Les mots de passe ne correspondent pas
        </mat-error>
        <mat-error
          *ngIf="confirmPassword?.getError('httpError') as httpError"
          class="form__error-red"
        >
          {{ httpError }}
        </mat-error>
      </div>
    </ng-container>

    <div class="form__actions">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="resetForm.invalid"
        [attr.loading]="STATE.isResettingUserPassword"
      >
        @if (STATE.isResettingUserPassword) {
          <span>Confirmation...</span>
        } @else {
          <span>Réinitialiser mon mot de passe</span>
        }
      </button>

      <p class="form__actions--text">
        Je me souviens de mon mot de passe ?
        <span>
          <a [routerLink]="routes.login" class="form__actions--link"
            >Se connecter</a
          >
        </span>
      </p>
    </div>
  </form>
}
